<template>
    <div class="lucky-bag" :class="{ 'lucky-bag--layout-mobile-stack': layoutMobileStack }">
        <div class="container">
            <my-popup :title="title" :is-show="isShow" @leftHandler="toggleShowPopup(false)" @animateEnd="animateEnd">
                <div class="content">
                    <div class="lucky-bag-item-outer" v-for="item in list" :key="item.id">
                    <div class="lucky-bag-item" :class="{ 'lucky-bag-item--touch-scroll': layoutMobileStack }">
                        <div class="lucky-bag-info">
                            <div class="left-img-box">
                                <img class="lucky-img" src="~assets/image/othersLive/lucky-bag.png" alt="福袋" title="福袋" />
                            </div>
                            <div class="right-info">
                                <div class="info-item title">{{ item.bag_name }}</div>
                                <div class="info-item scope">参与范围：{{ scopes[item.in_type - 1] }}</div>
                                <div class="info-item people-num">可中奖人：{{ item.winning_number }}人</div>
                                <div class="info-item word-order">参与口令：关注加粉丝团领取超值福袋</div>
                                <div class="info-item count-down">倒计时：{{ item.countdown }}s</div>
                            </div>
                        </div>
                        <div class="actions-button">
                            <el-button class="item not-send" v-if="item.status == 0" @click="release(item)">发送福袋</el-button>
                            <el-button class="item already-send" v-else>已发送</el-button>
                        </div>
                    </div>
                    </div>
                </div>
            </my-popup>
        </div>
    </div>
</template>

<script>
import MyPopup from "./containers/MyPopup";
export default {
    name: "LiveLuckyBag",
    data() {
        return {
            scopes: ["所有观众", "仅限粉丝"],
            // luckyBagImg: require("")
        };
    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        list: {
            type: Array,
            default: () => [],
        },
        /** 手机宫格：福袋行最小宽度，超出时横向滑动查看 */
        layoutMobileStack: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        title() {
            return `发布福袋 (${this.list.length})`;
        },
    },
    components: {
        MyPopup,
    },
    methods: {
        toggleShowPopup(state) {
            this.$emit("update:isShow", state);
        },
        release(item) {
            this.$emit("release", { check: "bag", item });
        },
        animateEnd() {
            this.isShow || this.$emit("animateEnd");
        },
    },
    mounted() {},
};
</script>

<style scoped lang="scss">
.lucky-bag--layout-mobile-stack {
    .info-item {
        font-size: 10px !important;
    }
    ::v-deep .el-scrollbar__wrap {
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch;
    }

    .lucky-bag-item-outer {
        overflow-x: auto;
        overflow-y: hidden;
        width: 100%;
        touch-action: pan-x;
        overscroll-behavior-x: contain;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
    }

    .lucky-bag-item--touch-scroll {
        box-sizing: border-box;
        min-width: 560px;
        width: max-content;
        max-width: none;

        .lucky-bag-info {
            overflow: visible;
            min-width: min-content;

            .right-info {
                flex: 1 0 auto;
                min-width: min-content;
                overflow: visible;

                .info-item {
                    overflow: visible;
                    text-overflow: clip;
                }
            }
        }

        .actions-button {
            flex-shrink: 0;
        }
    }
}

.lucky-bag {
    width: 100%;
    .container {
        .content {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;

            .lucky-bag-item-outer {
                width: 100%;
            }

            .lucky-bag-item {
                /* 列表行宽度作为 cqw 参照，便于缩略图、字号、按钮随弹层缩放 */
                container-type: inline-size;
                box-sizing: border-box;
                padding: 20px 30px;
                padding: clamp(12px, 3.5cqw, 20px) clamp(14px, 5cqw, 30px);
                border-bottom: 1px solid #ddd;
                .lucky-bag-info {
                    display: flex;
                    align-items: center;
                    min-width: 0;

                    .left-img-box {
                        flex-shrink: 0;
                        width: 90px;
                        width: clamp(56px, 17cqw, 90px);
                        aspect-ratio: 90 / 95;
                        .lucky-img {
                            display: block;
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                    }
                    .right-info {
                        flex: 1;
                        min-width: 0;
                        margin: 0 46px 20px;
                        margin: 0 clamp(12px, 9cqw, 46px) clamp(10px, 4cqw, 20px);
                        font-size: 16px;
                        font-size: clamp(12px, 3.6cqw, 16px);
                        color: #5c5c6f;
                        overflow: hidden;
                        .info-item {
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                        .title {
                            margin-bottom: 20px;
                            margin-bottom: clamp(8px, 3.5cqw, 20px);
                            font-size: 18px;
                            font-size: clamp(14px, 4.8cqw, 18px);
                            color: #1b162a;
                        }
                    }
                }
                .actions-button {
                    text-align: center;
                    .item {
                        box-sizing: border-box;
                        width: 130px;
                        width: clamp(96px, 24cqw, 130px);
                        height: 47px;
                        height: clamp(36px, 9cqw, 47px);
                        font-size: 16px;
                        font-size: clamp(13px, 3.5cqw, 16px);
                        letter-spacing: 2px;
                        letter-spacing: clamp(0px, 0.4cqw, 2px);
                        border-radius: 6px;
                    }
                    .not-send {
                        color: #fff;
                        background-color: #ed2612;
                        border: 2px solid #e8b579;
                    }
                    .already-send {
                        color: #cc855c;
                        background-color: #fbdebc;
                        cursor: default;
                    }
                }
            }
        }
    }
}
</style>
